module.exports = __webpack_public_path__ + "media/src/img/payment/tenge-1e251514b3a0c0913e21863144a791bd.svg";